import { class_type } from "../Docs/fable_modules/fable-library.3.7.1/Reflection.js";

export class Table {
    constructor() {
    }
}

export function Table$reflection() {
    return class_type("Feliz.TanStack.Table.Selection.Table", void 0, Table);
}

export function Table_setRowSelection(updater, table) {
    table._obj.setRowSelection(updater);
    return table;
}

export function Table_resetRowSelection(defaultValue, table) {
    return table._obj.resetRowSelection(defaultValue);
}

export function Table_getIsAllRowsSelected_Z4395D14A(table) {
    return table._obj.getIsAllRowsSelected();
}

export function Table_getIsAllPageRowsSelected_Z4395D14A(table) {
    return table._obj.getIsAllPageRowsSelected();
}

export function Table_getIsSomeRowsSelected_Z4395D14A(table) {
    return table._obj.getIsSomeRowsSelected();
}

export function Table_getIsSomePageRowsSelected_Z4395D14A(table) {
    return table._obj.getIsSomePageRowsSelected();
}

export function Table_getToggleAllRowsSelectedHandler_Z4395D14A(table) {
    table._obj.getToggleAllRowsSelectedHandler();
    return table;
}

export function Table_toggleAllRowsSelected_Z4395D14A(table) {
    const selected = Table_getIsAllRowsSelected_Z4395D14A(table);
    table._obj.toggleAllRowsSelected(!selected);
    return table;
}

export function Table_getPreSelectedRowModel_Z4395D14A(table) {
    return table._obj.getPreSelectedRowModel();
}

export function Table_getSelectedRowModel_Z4395D14A(table) {
    return table._obj.getSelectedRowModel();
}

export function Table_getFilteredSelectedRowModel_Z4395D14A(table) {
    return table._obj.getFilteredSelectedRowModel();
}

export function Table_getGroupedSelectedRowModel_Z4395D14A(table) {
    return table._obj.getGroupedSelectedRowModel();
}

export class Row {
    constructor() {
    }
}

export function Row$reflection() {
    return class_type("Feliz.TanStack.Table.Selection.Row", void 0, Row);
}

export function Row_getCanSelect_773C3262(row) {
    return row.getCanSelect();
}

export function Row_getCanMultiSelect_773C3262(row) {
    return row.getCanMultiSelect();
}

export function Row_getCanSelectSubRows_773C3262(row) {
    return row.getCanSelectSubRows();
}

export function Row_getIsSelected_773C3262(row) {
    return row.getIsSelected();
}

export function Row_getIsSomeSelected_773C3262(row) {
    return row.getIsSomeSelected();
}

export function Row_toggleSelected_773C3262(row) {
    if (Row_getCanSelect_773C3262(row)) {
        const isSelected = Row_getIsSelected_773C3262(row);
        row.toggleSelected(!isSelected);
    }
}

//# sourceMappingURL=Selection.fs.js.map
